// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"162":"76bafc16","170":"5a008de1","373":"07c29944","405":"f1d5914e","453":"e29d5eda","949":"6b56ee48"}[chunkId] + ".chunk.js";
};